import { FC } from 'react';
import { Box, Typography, Button } from '@mui/material';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useQuery } from 'react-query';
import { barnsService } from '../../services/barnsService';
import { useIsOffline } from '../../offline';
import BarnOperationsContent from '../Billing/BarnOperations';

const BarnOperationsPage: FC = () => {
  const navigate = useNavigate();
  const isOffline = useIsOffline();

  // Deep links from a barn's page arrive as ?barn=<name>. Resolve it back to
  // the Barn record so the back button returns to THAT barn; otherwise (or
  // offline / unmatched name) fall back to the Barns list.
  const [searchParams] = useSearchParams();
  const barnFromUrl = searchParams.get('barn');
  const { data: barns = [] } = useQuery(['barns'], () => barnsService.list(), {
    enabled: !isOffline,
    staleTime: 60_000,
  });
  const sourceBarn = barnFromUrl
    ? barns.find((b) => b.name.toLowerCase() === barnFromUrl.toLowerCase()) ?? null
    : null;

  return (
    <Box sx={{ overflowX: 'hidden', p: { xs: 1, sm: 1.5 } }}>
      <Button
        startIcon={<ArrowBackIcon />}
        onClick={() => (sourceBarn ? navigate(`/barns/${sourceBarn.id}`) : navigate('/barns'))}
        sx={{ mb: 0.5 }}
      >
        {sourceBarn ? sourceBarn.name : 'Barns'}
      </Button>
      <Box mb={{ xs: 1, sm: 1.5 }}>
        <Typography
          variant="h4"
          gutterBottom
          sx={{
            fontSize: { xs: '1.25rem', sm: '1.5rem', md: '2.125rem' },
            mb: { xs: 0.5, sm: 1 },
          }}
        >
          Barn Operations
        </Typography>
        <Typography
          color="textSecondary"
          sx={{
            fontSize: { xs: '0.8rem', sm: '0.875rem' },
            display: { xs: 'none', sm: 'block' },
          }}
        >
          Apply services to multiple horses by barn and auto-create invoices
        </Typography>
      </Box>
      <BarnOperationsContent />
    </Box>
  );
};

export default BarnOperationsPage;
